


























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { employeeApis, InvalidParam, LoginResult, ResetPasswordForm } from '../api';
import * as dd from 'dingtalk-jsapi';
import { AESFunction } from '@/common/cryptoAES';
import { CookieFunction } from '@/common/cookie';
import { getRedirectUrl, isSamlLogin } from '@/common';
import { Dialog, Toast } from 'vant';
import { DingtalkCorpId, isInDingtalk } from '@/common/dingtalk';
// @ts-ignore
import $ from 'jquery';

declare const CAPTCHA_SCENE_ID: string;

@Component
export default class Login extends Vue {
  readonly rules = {
    username: { required: true, message: '请输入账号' },
    code: { required: true, message: '请输入验证码' },
    new_password: { required: true, message: '请输入密码' },
    repeat_new_password: {
      required: true,
      validator: (rule: any, value: any, callback: any) => {
        if (value != this.resetForm.new_password) {
          callback(new Error('新密码不一致'));
        } else {
          callback();
        }
      }
    }
  };

  errors: Record<string, any> = {};
  form = { username: '', passwd: '', remerber: false };
  resetForm: ResetPasswordForm = {
    username: '',
    new_password: '',
    repeat_new_password: '',
    code: null,
    email: '',
    send_code: false
  };

  forgotPassword = false;
  timer: number | null = null;
  countDownNum = 60;
  codeDisable = false;
  pubKey = '';

  captcha: any = null;
  captchaButtonEle: HTMLElement | null = null;
  captchaRequired = false;
  loginResult: any = null;
  loginLoading = false;
  loginTimes = 1;

  async mounted() {
    if (this.$getEmployee()) {
      this.routeTo();
      return;
    }

    if (isInDingtalk()) {
      this.loginByDD();
      return;
    }

    if (CookieFunction.getCookie('username') && CookieFunction.getCookie('passwd')) {
      this.form.username = CookieFunction.getCookie('username');
      this.form.passwd = AESFunction.decrypt(CookieFunction.getCookie('passwd'));
      this.form.remerber = true;
    }

    if (!this.captcha) {
      this.initCaptcha();
    }
  }

  beforeUnmount() {
    this.captchaButtonEle = null;
    // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
    document.getElementById('aliyunCaptcha-mask')?.remove();
    document.getElementById('aliyunCaptcha-window-popup')?.remove();
  }

  initCaptcha() {
    this.captchaButtonEle = document.getElementById('login-button');

    // @ts-ignore
    window.initAliyunCaptcha({
      SceneId: CAPTCHA_SCENE_ID, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      prefix: process.env.VUE_APP_CAPTCHA_PREFIX, // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: '#login-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
      onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
      getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
      slideStyle: {
        width: 240,
        height: 32
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: 'cn' // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    });
  }

  loginByDD() {
    dd.ready(() => {
      dd.runtime.permission
        .requestAuthCode({
          corpId: DingtalkCorpId
        })
        .then(async info => {
          const code = info.code; // 通过该免登授权码可以获取用户身份
          const result = await employeeApis.loginByDingtalk(code);
          this.updateEmployee(result);
          this.routeTo();
        });
    });
  }

  login() {
    this.captchaButtonEle?.click();
  }

  updateEmployee(result: LoginResult) {
    this.$store.commit('employee/update', result.employee);
    this.$store.commit('perms/update', result.perms);
  }

  routeTo() {
    if (typeof this.$route.query.redirect === 'string') {
      const redirect_url = getRedirectUrl(this.$route);
      if (redirect_url && typeof redirect_url == 'string') {
        if (redirect_url.slice(0, 4) === 'http') {
          window.open(redirect_url, '_self');
        } else {
          this.$router.push(redirect_url);
        }
      } else {
        this.$router.push('/');
      }
    } else {
      this.$router.push('/');
    }
  }

  getInstance(instance: any) {
    this.captcha = instance;
  }

  /**copy from desktop login */
  async loginWithCaptcha(captcha: any): Promise<{ bizResult: boolean; captchaResult: boolean }> {
    this.errors = {};
    const encryptStr = new this.$jsEncrypt();
    const pubKeyResult = await employeeApis.getPublicKey();
    this.pubKey = pubKeyResult.key;
    const timestamp1 = pubKeyResult.timestamp;
    encryptStr.setPublicKey(this.pubKey); // 设置 加密公钥
    const data = encryptStr.encrypt(this.form.passwd.toString() + '&' + timestamp1); // 进行加密
    const loginForm = { username: this.form.username, passwd: data };
    this.loginResult = null;
    this.loginLoading = true;

    try {
      if (isSamlLogin(this.$route)) {
        this.loginResult = await employeeApis.loginSaml(loginForm);
      } else {
        this.loginResult = await employeeApis.loginWithCaptcha(loginForm, captcha, this.loginTimes);
      }
      return { bizResult: true, captchaResult: true };
    } catch (e) {
      const result = { bizResult: false, captchaResult: true };
      if (e instanceof InvalidParam) {
        if (e.captcha_required()) {
          this.captchaRequired = true;
        }
        // 判断是否是验证码错误
        if (e.captcha_error()) {
          result.captchaResult = false;
        } else {
          this.errors = e.params;
          CookieFunction.clearLoginForm();
        }
        // 判断是否自动触发再次登录操作
        if (e.captcha_retry()) {
          this.login();
        }
      } else {
        this.$notify.error(e.message);
      }
      return result;
    } finally {
      this.loginTimes += 1;
      this.loginLoading = false;
    }
  }

  async reset_passwd() {
    if (this.resetForm.new_password !== this.resetForm.repeat_new_password) {
      Toast.fail('两次输入的密码不一致');
      return;
    }
    try {
      const encryptStr = new this.$jsEncrypt();
      const pubKeyResult = await employeeApis.getPublicKey();
      this.pubKey = pubKeyResult.key;
      const timestamp = pubKeyResult.timestamp;
      encryptStr.setPublicKey(this.pubKey); // 设置 加密公钥
      const new_data = encryptStr.encrypt(this.resetForm.new_password.toString() + '&' + timestamp);
      const new_repeat_data = encryptStr.encrypt(this.resetForm.repeat_new_password.toString() + '&' + timestamp);
      const resetForm = {
        username: this.resetForm.username,
        new_password: new_data,
        repeat_new_password: new_repeat_data,
        code: this.resetForm.code,
        email: this.resetForm.email,
        send_code: this.resetForm.send_code
      };
      const res = await employeeApis.resetPassword(resetForm);
      this.updateEmployee(res);
      if (CookieFunction.getCookie('username') && CookieFunction.getCookie('passwd')) {
        CookieFunction.updateLoginForm(undefined, AESFunction.encrypt(this.resetForm.new_password));
      }

      // 如果是内部员工提示一下密码的用途;
      if (!this.$currentIsExternal()) {
        try {
          await Dialog.alert({
            message: this.$passwordTips
          });
        } catch {}
      }

      this.routeTo();
      this.$notify.success('密码已重新设置成功，自动登录');
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
        this.$message.error(Object.values(e.params).join('/'));
      } else {
        this.$notify.error(e.message);
      }
    }
  }

  async sendEmailCode() {
    const TIME_COUNT = 60;
    this.codeDisable = true;
    this.countDownNum = TIME_COUNT;
    this.resetForm.send_code = true;
    try {
      const result = await employeeApis.getEmailCode(this.resetForm);
      this.forgotPassword = true;
      this.resetForm.email = (result as any).email;
      this.$notify.success(`验证码已发送至${this.resetForm.email}`);
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        this.$notify.error(e.message);
      }
    }
    this.timer = setInterval(() => {
      if (this.countDownNum > 0 && this.countDownNum <= TIME_COUNT) {
        this.countDownNum--;
      } else {
        this.codeDisable = false;
        clearInterval(this.timer as number);
        this.timer = null;
      }
    }, 1000);
  }

  setUserInfo() {
    if (this.form.remerber) {
      CookieFunction.updateLoginForm(this.form.username, AESFunction.encrypt(this.form.passwd));
    }
  }

  async captchaVerifyCallback(captchaVerifyParam: Record<string, any>) {
    return await this.loginWithCaptcha(captchaVerifyParam);
  }

  onBizResultCallback(bizResult: boolean) {
    if (bizResult && this.loginResult) {
      if (this.loginResult.html) {
        this.setUserInfo();
        $('html').html(this.loginResult.html);
        document.forms[0].submit();
      } else {
        this.updateEmployee(this.loginResult);
        this.routeTo();
        this.setUserInfo();
      }
    }
  }
}
